/**
 * Deterministic pseudo-randomness for demo mock data: the same seed always
 * yields the same value, so mocked numbers never jump between renders or tabs.
 */
const hashSeed = (value: string): number => {
  let hash = 0x811c9dc5;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
};

/** mulberry32 — small, fast and stable across browsers. Returns 0..1. */
export function seededRatio(seed: string): number {
  let state = (hashSeed(seed) + 0x6d2b79f5) >>> 0;
  state = Math.imul(state ^ (state >>> 15), state | 1);
  state ^= state + Math.imul(state ^ (state >>> 7), state | 61);
  return ((state ^ (state >>> 14)) >>> 0) / 4294967296;
}

/** Seeded value in [-1, 1], for jittering a metric around its mean. */
export function seededSwing(seed: string): number {
  return seededRatio(seed) * 2 - 1;
}
